// Routes rendered before a session exists. Onboarding tooltips neither load nor scan there.
const PUBLIC_ROUTE_PREFIXES: readonly string[] = [
  "/login",
  "/forgotpassword",
  "/changepassword",
  "/passwordchangesuccess",
  "/resetpassword",
  "/confirm-email",
  "/invitation",
  "/email-confirmation",
  "/redirect",
  "/unsupported-device"
];

export const isOnboardingPublicRoute = (pathname: string): boolean =>
  pathname === "/" || PUBLIC_ROUTE_PREFIXES.some((prefix: string): boolean => pathname.startsWith(prefix));
